import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { getEmbedSession, isEmbedMode } from 'v2/shared/utils/embed-session'
import { logger } from 'v2/utils/logger'
import { getLocalAuth } from '../../index'

export function formatPhoneNumberWithExtension(phoneNumber: string): {
  formattedNumber: string | null
  extension?: string
} {
  try {
    // Check for the sip endpoint
    if (phoneNumber.startsWith('sip:')) {
      return {
        formattedNumber: phoneNumber,
        extension: '',
      }
    }

    const formatted = phoneNumber.replace(/[-()\s]/g, '')
    const parsedNumber = parsePhoneNumberFromString(formatted)
    if (!parsedNumber) return { formattedNumber: null }

    const extension = parsedNumber.ext
    const numberWithoutExt = parsedNumber.number
    const formattedNumber = numberWithoutExt

    return {
      formattedNumber,
      extension,
    }
  } catch (e) {
    logger.error('Error formatting phone number', { error: e })
    return { formattedNumber: null }
  }
}

export function isAnonymousCallerId(callerId: string): boolean {
  const anonymousCallerIds = ['anonymous', 'restricted', 'private', 'unavailable']
  return anonymousCallerIds.includes(callerId.toLowerCase())
}

// The AOM a call is placed as. The embed has no console login, so it is the session's user.
export const callerAomUuid = (): string =>
  (isEmbedMode() ? getEmbedSession()?.aom_uuid : getLocalAuth().aom_uuid) ?? ''

// Browser audio processing for agent calls. With human-agent voice on, the browser defaults stay;
// otherwise auto gain lifts quiet calls. goog* keys are Chrome's legacy names for the same knobs.
const PROCESSED_AUDIO = {
  echoCancellation: true,
  noiseSuppression: false,
  autoGainControl: true,
  googEchoCancellation: true,
  googEchoCancellation2: true,
  googNoiseSuppression: false,
  googNoiseSuppression2: false,
  googHighpassFilter: false,
  googAutoGainControl: true,
  googAutoGainControl2: true,
}

export const voiceAudioConstraints = (
  channelVoiceEnabled: boolean,
): MediaTrackConstraints | undefined => (channelVoiceEnabled ? undefined : PROCESSED_AUDIO)
